<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="设备">
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_list,dev_name,id,del_flag=0 order by sort asc"
                placeholder="请选择设备"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="类型">
              <j-multi-select-tag
                :options="typeOptions"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.type"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="状态">
              <j-multi-select-tag
                dictCode="wf_complaint_status"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.comStatus"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('投诉报修')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="comStatus" slot-scope="text, record">
          <span>
            <a-tag :color="calcComStatusColor(record.comStatus)">{{record.comStatus_dictText}}</a-tag>
          </span>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            preview
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="appUserSlot" slot-scope="text, record">
          <a @click="showUser(record)">{{text}}</a>
        </span>
        <span slot="devSlot" slot-scope="text, record">
          <a @click="showDevDefects(record)">{{text}}</a>
        </span>
        <span slot="defectSlot" slot-scope="text, record">
          <a @click="showDefectDetail(record)">{{text}}</a>
        </span>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.comStatus== '0' || record.comStatus== 'seen'">
            <a @click="resolve(record)">处理</a>
            <a-divider type="vertical" />
            <a @click="defectRegister(record)">转缺陷</a>
            <a-divider type="vertical" />
            <a @click="close(record)">关闭</a>
          </template>

          <a-divider type="vertical" />
          <a @click="readDetail(record)">详情</a>
        </span>
      </a-table>
    </div>

    <wf-dev-complaint-modal @ok="modalFormOk" ref="modalForm"></wf-dev-complaint-modal>

    <wf-consumer-user-modal @ok="modalFormOk" ref="consumerUserModal"></wf-consumer-user-modal>

    <!-- 设备缺陷列表模态框 -->
    <a-modal
      :destroyOnClose="true"
      :footer="null"
      :title="defectModalTitle"
      :visible="defectModalVisible"
      :width="1400"
      @cancel="handleDefectModalCancel"
    >
      <def-register-list-for-detail :query="defectQuery" ref="defRegisterList" v-if="defectModalVisible"></def-register-list-for-detail>
    </a-modal>

    <j-modal
      :title="showDealModalTitle"
      :visible="showDealModal"
      :width="600"
      @cancel="cancelEditRecord"
      @ok="editRecord"
      cancelText="取消"
    >
      <a-form>
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="dealDescLabel">
              <a-textarea rows="4" v-model="dealDesc" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form>
    </j-modal>

    <def-register-modal @ok="registerModalFormOk" ref="registerModalForm"></def-register-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfDevComplaintModal from './modules/WfDevComplaintModal'
  import WfConsumerUserModal from './modules/WfConsumerUserModal'
  import DefRegisterListForDetail from '@/views/equipment/defect/vue/DefRegisterListForDetail'
  import DefRegisterModal from '@views/equipment/defect/vue/modules/DefRegisterModal'

  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { getAction, putAction } from '@/api/manage'

  export default {
    name: 'WfDevComplaintList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfDevComplaintModal,
      WfConsumerUserModal,
      DefRegisterListForDetail,
      DefRegisterModal
    },
    data () {
      return {
        description: '投诉报修管理页面',

        typeOptions: [
          { label: '投诉', value: '投诉' },
          { label: '报修', value: 'repair' }
        ],

        statusOptions: [
          { label: '未处理', value: '0' },
          { label: '已处理', value: '1' }
        ],
        // 表头
        columns: [
          {
            title: '反馈用户',
            align: "center",
            sorter: true,
            dataIndex: 'wfUserId_dictText',
            scopedSlots: { customRender: 'appUserSlot' }
          },
          {
            title: '设备',
            align: "center",
            sorter: true,
            dataIndex: 'devId_dictText',
            scopedSlots: { customRender: 'devSlot' }
          },
          {
            title: '时间',
            align: "center",
            sorter: true,
            dataIndex: 'createTime'
          },
          {
            title: '类型',
            align: "center",
            sorter: true,
            dataIndex: 'type',
            customRender: (t, r, index) => {
              const option = this.typeOptions.find(item => item.value === t);
              return option?.label || '其他';
            }
          },
          {
            title: '描述',
            align: "center",
            dataIndex: 'description'
          },
          {
            title: '图片',
            align: "center",
            dataIndex: 'images',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '状态',
            align: "center",
            sorter: true,
            scopedSlots: { customRender: 'comStatus' }
          },
          {
            title: '缺陷单',
            align: "center",
            dataIndex: 'defectId',
            scopedSlots: { customRender: 'defectSlot' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        isorter: {
          column: 'createTime',
          order: 'desc',
        },
        ipagination: {
          pageSize: 30,
        },
        url: {
          list: "/wf/complaint/list",
          delete: "/wf/complaint/delete",
          deleteBatch: "/wf/complaint/deleteBatch",
          exportXlsUrl: "/wf/complaint/exportXls",
          importExcelUrl: "wf/complaint/importExcel",
          edit: "/wf/complaint/edit",

          appUserList: "/custom/user/list",

        },
        dictOptions: {},
        superFieldList: [],
        // 设备缺陷模态框相关
        defectModalVisible: false,
        defectModalTitle: '设备缺陷列表',
        defectQuery: {},

        editedRecord: null,
        showDealModal: false,
        showDealModalTitle: '直接处理',
        dealDescLabel: '处理过程描述',
        dealDesc: '',
        validatorRules: {
          dealDesc: [{ required: true, message: `请输入${this.dealDescLabel}!` }],
        },
      }
    },
    filters: {
      filterComStatus (value) {
        if (value === '0') {
          return '未处理'
        } else if (value === '1') {
          return '已处理'
        } else {
          return '未知'
        }
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      resolve (record) {
        this.editedRecord = JSON.parse(JSON.stringify(record));
        this.editedRecord.comStatus = 'resolved';
        this.showDealModal = true;
        this.showDealModalTitle = '直接处理';
        this.dealDescLabel = '处理过程描述';
      },
      close (record) {
        this.editedRecord = JSON.parse(JSON.stringify(record));
        this.editedRecord.comStatus = 'closed';
        this.showDealModal = true;
        this.showDealModalTitle = '关闭';
        this.dealDescLabel = '关闭原因';
      },
      editRecord () {
        if (!this.dealDesc) {
          this.$message.error(`请输入${this.dealDescLabel}!`);
          return;
        }
        const model = {
          id: this.editedRecord.id,
          comStatus: 'resolved',
          dealDesc: this.dealDesc,
        }
        putAction(this.url.edit, model).then((res) => {
          if (res.success) {
            this.$message.success(`处理成功`);
            this.searchQuery();
            this.cancelEditRecord()
          } else {
            this.$message.error(res.message);
          }
        }).catch(() => {
          this.$message.error('处理失败');
        });
      },
      cancelEditRecord () {
        this.editedRecord = null;
        this.showDealModal = false;
        this.dealDesc = '';
      },
      defectRegister (record) {
        this.editedRecord = JSON.parse(JSON.stringify(record));
        this.$refs.registerModalForm.add(record.devId)
        this.$refs.registerModalForm.title = '登记缺陷'
        this.$refs.registerModalForm.disableSubmit = false
      },
      registerModalFormOk (defRegisterId) {
        this.editedRecord.dealDesc = 'defected';
        this.editedRecord.defectId = defRegisterId;
        this.edit(this.curItem)
      },
      showUser (record) {
        getAction(this.url.appUserList, { id: record.wfUserId }).then((res) => {
          if (res.success) {
            const data = res.result.records[0]
            if (data) {
              this.$refs.consumerUserModal.edit(data);
              this.$refs.consumerUserModal.title = "用户信息";
              this.$refs.consumerUserModal.disableSubmit = true;
            } else {
              this.$message.warning('未找到用户信息，请确认用户是否已删除或禁用')
            }
          }
        }).catch(() => {
          this.$message.error('查询用户信息失败,请稍后再试')
        })
      },
      readDetail (record) {
        // 如果状态为未读，则标记为已读
        if (record.comStatus === '0') {
          const model = {
            id: record.id,
            comStatus: 'seen'
          }
          putAction(this.url.edit, model).then((res) => {
            if (res.success) {
              this.searchQuery();
            }
          });
        }
        this.handleDetail(record);
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'wfUserId', text: '投诉用户', dictCode: '`iwt-wf`.wf_consumer_user,nickname,id' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备', dictCode: '`iwt-wf`.dev_list,dev_name,id' })
        fieldList.push({ type: 'string', value: 'type', text: '类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'description', text: '描述', dictCode: '' })
        fieldList.push({ type: 'string', value: 'images', text: '图片', dictCode: '' })
        fieldList.push({ type: 'string', value: 'videos', text: '视频', dictCode: '' })
        fieldList.push({ type: 'string', value: 'comStatus', text: '状态', dictCode: '' })
        fieldList.push({ type: 'int', value: 'priority', text: '优先级', dictCode: '' })
        this.superFieldList = fieldList
      },
      /**
       * 显示设备缺陷列表
       * @param {Object} record - 当前行记录
       */
      showDevDefects (record) {
        if (!record.devId) {
          this.$message.warning('设备信息不完整，无法查看缺陷列表')
          return
        }

        // 设置查询参数，只查询该设备的缺陷
        this.defectQuery = {
          devId: record.devId
        }

        this.defectModalTitle = `设备缺陷列表 - ${record.devId_dictText || '未知设备'}`
        this.defectModalVisible = true
      },
      /**
       * 关闭设备缺陷模态框
       */
      handleDefectModalCancel () {
        this.defectModalVisible = false
        this.defectQuery = {}
      },
      calcComStatusColor (comStatus) {
        const statusMap = {
          '0': '#faad14',
          'seen': '#f50',
          'resolved': '#52c41a',
          'defected': '#52c41a',
          'closed': '#52c41a',
        };
        return statusMap[comStatus] || '#000000';
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';

  /* 确保图片列不影响其他列的对齐 */
  .j-table-force-nowrap td img {
    vertical-align: top;
  }
</style>